


































import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import CPing from '~/components/shared/configurable/timeline/CPing.vue'
import { PingVariant } from '~/models/app/ping'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'

export default defineComponent({
  components: { CShimmer, CPing },
  props: {
    datetime: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    variant: {
      type: String as PropType<PingVariant>,
      default: null
    },
    ping: {
      type: Boolean,
      default: false
    },
    descriptionClass: {
      type: String,
      required: false,
      default: 'tw-text-grey-500'
    }
  }
})
